import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../components/Button';
import { Rating } from '../components/Rating';
interface ReviewProps {
  tripId: string;
  onBack: () => void;
  onComplete: () => void;
  onSubmitClaim?: () => void;
}
export function Review({
  onBack,
  onComplete,
  onSubmitClaim
}: ReviewProps) {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  return <div className="min-h-screen bg-cream pb-24" data-id="element-1530">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-white border-b border-sand" data-id="element-1531">
        <div className="max-w-md mx-auto px-3 py-2 flex items-center" data-id="element-1532">
          <button onClick={onBack} className="p-1.5 -ml-1 hover:bg-sand/20 rounded-full transition-colors" data-id="element-1533">
            <ChevronLeft size={22} className="text-charcoal" data-id="element-1534" />
          </button>
          <h1 className="flex-1 text-base font-bold text-charcoal text-center pr-8" data-id="element-1535">
            Review & Inspect
          </h1>
        </div>
      </div>

      <div className="max-w-md mx-auto" data-id="element-1536">
        {/* Instruction Text */}
        <div className="px-3 pt-3" data-id="element-1537">
          <p className="text-xs text-charcoal/80 leading-relaxed" data-id="element-1538">
            If your item was not returned to you as expected, please submit a
            claim with AllHere's Support team within 7 days of the item being
            returned.
          </p>
        </div>

        {/* Review Section (Optional) */}
        <div className="px-3 mt-4" data-id="element-1539">
          <label className="block text-xs font-bold text-charcoal mb-2" data-id="element-1540">
            Leave Review for Alex T. (optional)
          </label>

          {/* Star Rating */}
          <Rating value={rating} size={24} interactive onChange={setRating} data-id="element-1541" />

          {/* Review Question */}
          <p className="text-[11px] font-bold text-charcoal mt-2" data-id="element-1542">
            How was your experience lending to Alex T.?
          </p>

          {/* Review Text Area */}
          <textarea value={reviewText} onChange={e => setReviewText(e.target.value)} placeholder="You can mention the item, communication, or how everything went overall." className="w-full h-[120px] mt-2 p-2.5 border border-sand rounded text-xs text-charcoal placeholder-moss-gray leading-relaxed focus:outline-none focus:ring-1 focus:ring-dark-green focus:border-dark-green resize-y" data-id="element-1543" />
        </div>

        {/* Action Buttons */}
        <div className="px-3 mt-3 mb-16 space-y-2" data-id="element-1544">
          <Button variant="primary" fullWidth onClick={onComplete} data-id="element-1545">
            Complete Booking
          </Button>

          <Button variant="secondary" fullWidth onClick={onSubmitClaim} data-id="element-1546">
            Submit Claim
          </Button>
        </div>
      </div>
    </div>;
}